import {createContext, useContext} from "react";

const ClientOnboardingContext = createContext(null);

export const useClientOnboardingContext = () =>
  useContext(ClientOnboardingContext);

export default ClientOnboardingContext;
